import {
  SiteConfigurationStepData,
  AccountResponse,
  CustomerInformationStepData,
  PressureTypeFull,
  SaveSiteGeneralConfigurationPayload,
  SaveOnboardingFormPayload,
  STATION_USAGE_TYPES,
} from '../constants';
import { splitFullName } from './customerInformationStepAdapter';

export const convertSiteConfigurationStepDataToDTO = (
  siteConfigurationStepData: SiteConfigurationStepData,
): SaveSiteGeneralConfigurationPayload => {
  const numberCompressorRooms =
    siteConfigurationStepData.compressorRooms === 'other' &&
    siteConfigurationStepData.otherCompressorRooms !== undefined
      ? siteConfigurationStepData.otherCompressorRooms
      : typeof siteConfigurationStepData.compressorRooms === 'number'
      ? siteConfigurationStepData.compressorRooms
      : 1;

  const numberEntryPointsMainHeader =
    siteConfigurationStepData.entryPoints === 'other' && siteConfigurationStepData.otherEntryPoints !== undefined
      ? siteConfigurationStepData.otherEntryPoints
      : typeof siteConfigurationStepData.entryPoints === 'number'
      ? siteConfigurationStepData.entryPoints
      : 1;

  const config: SaveSiteGeneralConfigurationPayload = {
    numberCompressorRooms,
    numberEntryPointsMainHeader,
    systemControllerType: siteConfigurationStepData.systemControllerType,
    stationNameSuffix: siteConfigurationStepData.stationNameSuffix,
    isManyTargetPressure: siteConfigurationStepData.hasMultipleTargetPressures,
  };

  if (siteConfigurationStepData.hasMultipleTargetPressures && siteConfigurationStepData.pressureType) {
    const type = siteConfigurationStepData.pressureType.toLowerCase();
    if (type === PressureTypeFull.LOW) {
      config.pressureType = PressureTypeFull.LOW;
    } else if (type === PressureTypeFull.MEDIUM) {
      config.pressureType = PressureTypeFull.MEDIUM;
    } else if (type === PressureTypeFull.HIGH) {
      config.pressureType = PressureTypeFull.HIGH;
    }
  } else {
    config.pressureType = PressureTypeFull.MAIN;
  }

  return config;
};

export const prepareSiteConfigurationStepPayload = (
  customerInformationStepData: CustomerInformationStepData,
  siteConfigurationStepData: SiteConfigurationStepData,
  accountData: AccountResponse | null,
  formId: string | null,
): SaveOnboardingFormPayload => {
  if (!formId) {
    throw new Error('No form ID available. Please save Step 1 data first.');
  }

  const { firstName, lastName } = splitFullName(customerInformationStepData.contactPerson.fullName || '');
  const { firstName: accountManagerFirstName, lastName: accountManagerLastName } = splitFullName(
    customerInformationStepData.accountManager?.fullName || '',
  );
  const siteGeneralConfiguration = convertSiteConfigurationStepDataToDTO(siteConfigurationStepData);

  return {
    salesforceAccountId: customerInformationStepData.customer?.accountId || '',
    formId,
    siteData: {
      generalData: {
        siteAddress: {
          streetAddress: customerInformationStepData.siteAddress.streetAddress || '',
          city: customerInformationStepData.siteAddress.city || '',
          state: customerInformationStepData.siteAddress.state || '',
          country: customerInformationStepData.siteAddress.country || '',
          zipCode: customerInformationStepData.siteAddress.zipCode || '',
        },
        contactPerson: {
          firstName,
          lastName,
          email: customerInformationStepData.contactPerson.email || '',
        },
        accountManager: {
          firstName: accountManagerFirstName,
          lastName: accountManagerLastName,
          email: customerInformationStepData.accountManager?.email || '',
        },
        stationTier: customerInformationStepData.tier || '',
        stationUsageType: customerInformationStepData.stationUsageType || STATION_USAGE_TYPES.REGULAR,
        ecoplantCustomerId: customerInformationStepData.account || null,
        customerName: accountData?.customerName || customerInformationStepData.newCustomerName || '',
        channelIdentifier: accountData?.cgOrgChannelC || '',
      },
      siteGeneralConfiguration,
    },
  };
};
